import { render, staticRenderFns } from "./LeadsCardPrice.vue?vue&type=template&id=8f2ab6f8&scoped=true&"
import script from "./LeadsCardPrice.vue?vue&type=script&lang=js&"
export * from "./LeadsCardPrice.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCardPrice.vue?vue&type=style&index=0&id=8f2ab6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2ab6f8",
  null
  
)

export default component.exports